import dayjs from "dayjs";
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import {vsiGreen, vsiRed} from "./themeStyles";
import {lightOrDark, getColor} from "./Helpers";
import { VsiButton, VsiP, VsiSpanText } from "../styled/App.styled";
import {getAutobot, getReport, UpdateVirtualHealth, GetAuth, PutAuth} from "./Verbs";
import {useVsiAppContext} from "../stores/VsiApp";
import React, { useState, useEffect } from "react";
import { Button, Input, Progress, Spinner } from "reactstrap";
import {roundToNearestTenth} from "./math";
import VsiModal from "../components/VsiModal";

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);


export const uploadStatusFormatter = params => {
    // const value = params.value?.toLowerCase();
    // //<div style={{width: '100%'}}>
    // return <div style={{width: '100%'}} className={`badge bg-${value in ["enqueued"] ? 'info' :
    //     value in ["parsing", "processing", "finishing", "extracting-files", "processing-etl", "re-uploading"] ? 'primary' :
    //         value in ['success', 're-uploaded'] ? 'success' :
    //             value === 'reset' ? 'warning' : value === 'deleted' ? 'secondary' : value?.includes('error') ? 'danger' : ''}`}>{params.value}</div>;
    // // </div>


    switch (params.value?.toLowerCase()) {
        case "enqueued":
            return <div style={{width: '100%'}}>
                <span style={{width: '100%', textAlign: "center"}} className="badge bg-info text-dark">
                    <i className="fa-solid fa-timer"/> Waiting...</span>
            </div>;
        case "parsing":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-primary">Parsing...<Progress
                    animated striped value={25}/></div>
            </div>
        case "processing":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-primary">Processing...</div>
            </div>
        case "finishing":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-primary">Finishing...<Progress
                    animated striped value={95}/></div>
            </div>
        case "extracting-files":
            return <div style={{width: '100%', textAlign: "center"}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-primary">Extracting
                    Files...<Progress animated striped value={10}/></div>
            </div>
        case "processing-etl":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-primary">Processing
                    ETL...<Progress animated striped value={75}/></div>
            </div>
        case "success":
            return <div style={{width: '100%', textAlign: "center"}} className="badge bg-success">
                <i className="fa-solid fa-check"/> Completed
            </div>
        case "reset":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-warning">Reset</div>
            </div>
        case "deleted":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-secondary">
                    <i className="fa-solid fa-trash"/> Marked Deleted
                </div>
            </div>
        case "re-uploading":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-primary">
                    <Spinner color={"light"} size={"sm"}/> Re-Uploading
                </div>
            </div>
        case "re-uploaded":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-success">Re-Uploaded</div>
            </div>
        case "error-device":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-danger">
                    <i className="fa-solid fa-xmark"/> Error-Device
                </div>
            </div>
        case "error-parser":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-danger">
                    <i className="fa-solid fa-xmark"/> Error-Parser
                </div>
            </div>;
        case "error-etl":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-danger">
                    <i className="fa-solid fa-xmark"/> Error-ETL
                </div>
            </div>
        case "marked-failed":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-danger">
                    <i className="fa-solid fa-xmark"/> Marked Failed
                </div>
            </div>
        case "error":
            return <div style={{width: '100%'}}>
                <div style={{width: '100%', textAlign: "center"}} className="badge bg-danger">
                    <i className="fa-solid fa-xmark"/> Error
                </div>
            </div>
        case "(select all)":
            return '(Select All)';
        default:
            return null;
    }
};

export const DownloadLinkFormatter = params => {
    const { getAccessTokenSilently } = useVsiAppContext();
    const [userToken, setUserToken] = useState('');

    useEffect(() => {
        const getAndSetToken = async () => {
            setUserToken(await getAccessTokenSilently());
        }
        if (!userToken) {
            getAndSetToken();
        }
    }, [getAccessTokenSilently, userToken]);

    let jobId = params?.data?._id;
    let client = params?.data?.clientName?.[0]?.name || params?.data?.clientName;
    let status = params?.data?.parsingStatus;
    let device = params?.data?.deviceTypeCode;
    let filename = params.value;
    if (!client || !status || !device || !filename) {
        return <span>{filename}</span>
    } else if (status === 'success' || status.includes('error') || status === 're-uploaded' || status === 'marked-failed') {
        return (
            <a className="text-decoration-none"
               href={`${window.location.origin}/api/v6/upload/download/${userToken}/${jobId}/${filename}`} download>
                {filename}
            </a>
        )
    } else {
        return <span>{filename}</span>
    }
};

export const reUploadLinkFormatter = params => {
    // Attempt to make re-upload formatter, which make a POST request to upload API when clicked.
    let _id = params?.data?._id;
    let status = params?.data?.parsingStatus;
    if (status === 'success' || status?.includes('error') || status === 're-uploaded' || status === 'marked-failed') {
        const reUploadButtonClick = async (event) => {
            event.preventDefault();
            event.target.innerHTML = 'In Progress';
            event.target.disabled = true;
            try {
                await fetch(`${window.location.origin}/api/v6/upload/re_upload/${_id}`, {
                    method: 'PUT',
                });
            } catch (error) {
                console.log('Re-parse error')
            }
        };

        return (
            <VsiButton className="btn btn-sm" onClick={reUploadButtonClick}><i
                className="fa-solid fa-arrows-rotate"/> Re-Parse</VsiButton>
        )
    } else {
        return <span></span>
    }
};

export const RunAutobotBtnFormatter = params => {
    const { getAccessTokenSilently } = useVsiAppContext();
    let clientId = params?.data?.clientId
    if (clientId) {
        const runAutobotClick = async (event) => {
            event.preventDefault();
            event.target.innerHTML = 'Running';
            event.target.disabled = true;
            try {
                const token = await getAccessTokenSilently();
                await getAutobot(`/api/v6/autobot/client/${clientId}`, token);
                event.target.innerHTML = 'Done';
                event.target.disabled = false;
            } catch (error) {
                if (error.response.status === 504) {
                    event.target.innerHTML = 'Done';
                    event.target.disabled = false;
                } else {
                    console.log('Autobot error')
                    event.target.innerHTML = `Failed - ${error.response?.statusText || error.message}`;
                    event.target.disabled = false;
                }
            }
        };

        return (
            <VsiButton className="btn btn-sm" onClick={runAutobotClick}>Run</VsiButton>
        );
    } else {
        return;
    }
};

export const MarkFailedFormatter = params => {
    const { getAccessTokenSilently } = useVsiAppContext();

    let stampedFileName = params?.data?.stampedFileName;
    let status = params?.data?.parsingStatus;
    let cannotBeMarked = ['success', 're-uploaded', 'deleted', '(select all)', 'marked-failed',
        'error-device', 'error-parser', 'error-ETL'];
    if (!cannotBeMarked.includes(status) && stampedFileName) {
        const markFailedButtonClick = async (event) => {
            event.preventDefault();
            event.target.innerHTML = 'Marking';
            event.target.disabled = true;
            try {
                const userToken = await getAccessTokenSilently();
                await PutAuth(`/api/v6/admin/update_upload_status_by_filename/${encodeURIComponent(stampedFileName)}/marked-failed`, {}, userToken);
            } catch (error) {
                console.log('Mark Failed Error')
            }
        };
        return (
            <VsiButton className="btn btn-sm" onClick={markFailedButtonClick}><i
                className="fa-solid fa-arrows-rotate"/> Mark Failed</VsiButton>
        )
    } else {
        return <span></span>
    }
};

export const RunGrowthRateButtonFormatter = params => {
    const { getAccessTokenSilently } = useVsiAppContext();
    let clientId = params?.data?.clientId;
    let color = ''
    const runGrowthRateClick = async (event) => {
        event.preventDefault();
        event.target.innerHTML = 'Running';
        event.target.disabled = true;
        try {
            const token = await getAccessTokenSilently();
            const response = await GetAuth(`/api/v6/report/enterprise_calculate_growth_rate_proc?client_id=${clientId}`, token);
            if (response) {
                event.target.innerHTML = 'Complete!';
            }
        } catch (error) {
            event.target.innerHTML = 'Failed';
            event.target.disabled = false;
        }

    };
    if (clientId) {
        // note this means if there isn't a client id passed on the row there won't be a button.
        return (<VsiButton className={`btn btn-sm btn-${color}`} onClick={runGrowthRateClick}>Run</VsiButton>);
    }
};

export const booleanFormatter = params => {
    if (params.value && JSON.parse(params.value) && Boolean(params.value)) return <i
        className="fa-solid fa-circle-check success"
        style={{color: vsiGreen}}/>
    else return <i className="fa-solid fa-circle-x danger" style={{color: 'red'}}/>
};

export const passwordRemovedFormatter = params => {
    if ((params?.node?.allChildrenCount || 0) > 0) return ''  // set empty for grouped head row
    else if (!params.value || params.value.length === 0) return 'Removed'
    else return 'Not Removed'
};


export const checkboxFormatter = params => {
    return (
        <div className={"d-flex justify-content-center align-items-center"}>
            <input type="checkbox" defaultChecked={params.value}/>
        </div>
    )
}
export const ipAddressFormatter = params => {
    return params.value || <span style={{fontStyle: 'italic'}}>Removed</span>;
}

const days = ['mon', 'tue', 'wed', 'thurs', 'fri', 'sat', 'sun'];
export const formatCollectionDay = (params) => {
    if (params.value) {
        let daysArr = params.value.split(',');
        let daysArrWithValues = daysArr.map(day => {
            let dayValue = days.indexOf(day);
            return {text: day, value: dayValue};
        });

        return daysArrWithValues.sort((a, b) => a.value - b.value).map(dayObj => dayObj.text).join(',');
    }
    return params.value;
}

export const autobotDateFormatter = params => {
    switch (params.value) {
        case null:
            return '';
        case 0:
            return 'Monday';
        case 1:
            return 'Tuesday';
        case 2:
            return 'Wednesday';
        case 3:
            return 'Thursday';
        case 4:
            return 'Friday';
        case 5:
            return <div style={{backgroundColor: "rgba(0,255,21,0.11)", width: "100%"}}>Saturday</div>;
        case 6:
            return <div style={{backgroundColor: "rgba(57,0,255,0.11)", width: "100%"}}>Sunday</div>;
        default:
            return null;
    }
};

export const dollarFormatter = params => {
    const locale = navigator.language || 'en-US';
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'USD',
    }).format(params?.value || 0);
}

export const downloadStatusFormatter = params => {
    switch (parseFloat(params.value)) {
        case 0:
            return <span className="cell-label label-default">Waiting</span>;
        case 1:
            return <span className="cell-label label-info">Processing</span>;
        case 2:
            return <span className="cell-label label-success">Sent</span>;
        case 3:
            return <span className="cell-label label-danger">Error</span>;
        default:
            return <span className="">Waiting for queue</span>;
    }
};

export const uomPreference = ({value}) => {
    if (value?.toLowerCase?.() === "gb") {
        return <div style={{width: "100%", textAlign: "center"}}>GiB</div>;
    } else if (value?.toLowerCase?.() === "tb") {
        return <div style={{width: "100%", textAlign: "center"}}>TiB</div>;
    } else if (value?.toLowerCase?.() === "pb") {
        return <div style={{width: "100%", textAlign: "center"}}>PiB</div>;
    } else return ""
};

export const autoBotButton = params => {
    let className = "btn-info run-auto-bot";
    let disabled = false;
    if (params?.data?.process_status !== null && params?.data?.process_status < 2) {
        className = "btn-disabled run-auto-bot";
        disabled = true;
    }
    return <button className={`${className} ${disabled ? ' disabled="true"' : ''} w-100`}>Run</button>
};


export const ServiceNowButton = params => {

    const { getAccessTokenSilently } = useVsiAppContext();
    const addIncident = async e => {
        const instance = params.data?.serviceNowInstance;
        if (e.target.innerText === 'Create Ticket') {
            e.target.disabled = false;
            const post_url = instance;
            const records = {
                "records":
                    [
                        {
                            "source": "visual1intelligence",
                            "source_instance": params.data?.context,
                            "time_of_event": dayjs().utc().format('YYYY-MM-DD HH:mm:ss'),
                            "node": params.data?.device_name,
                            "type": params.data?.context,
                            "resource": params.data?.id,
                            "metric_name": params.data?.alert,
                            "event_class": `${params.data?.context} Alerts`,
                            "message_key": params.data?.alert,
                            "severity": params.data?.severity.toLowerCase() === 'red' ? "1" : "2",
                            "description": params.data?.description,
                            "additional_info": `{"Device":"${params.data?.device_name}","errorDescription":${params.data?.description}, 
                            "visualone_id": ${params.data?.id}`
                        }
                    ]
            }
            await UpdateVirtualHealth(post_url, records, params.data?.serviceNowUser, params.data?.serviceNowPassword);
            const incident_id = params.data?.id;
            const incident_number = params.data?.id;
            const token = await getAccessTokenSilently();
            getReport(`/api/v6/report/${params.data?.stored_procedure}?id=${params.data?.id}&incident_id=${incident_id}&incident_number=${incident_number}`, null, token)
                .then(r => {
                    // const incident_url = `https://${instance}.service-now.com/nav_to.do?uri=event.do?sys_id=${incident_id}%26sysparm_view=ess`;
                    e.target.innerText = "Event Created";
                    e.target.value = incident_id;
                    e.target.className = "btn btn-info";
                    e.target.disabled = true;
                    // e.target.onClick = () => {
                    //     window.open(incident_url);
                    // }
                });
        } else {
            // window.open('https://dev226917.service-now.com/now/nav/ui/classic/params/target/%24pa_dashboard.do%3Fsysparm_dashboard%3Dbb4d9daa932a3200a346f179077ffb3d%26sysparm_tab%3D6e4265f093323200a346f179077ffb9e%26sysparm_cancelable%3Dtrue%26sysparm_editable%3Dfalse%26sysparm_active_panel%3Dfalse%26sysparm_ignore_default_filter%3Dfalse');
            // window.open(`https://${instance}.service-now.com/nav_to.do?uri=event.do?sys_id=${e.target.value}%26sysparm_view=ess`);
        }
    };
    if (params?.value === null && ['yellow', 'red'].indexOf(params.data?.severity.toLowerCase()) > -1) {
        const cl = params.data?.severity.toLowerCase() === 'yellow' ? "btn btn-warning" : "btn btn-danger";
        return <button className={cl} onClick={addIncident}>Create Ticket</button>
    } else if (!params?.value) {
        return null;
    } else {
        let incident_id = params?.data?.incident_id;
        // let incident_number = params?.data?.incident_number;
        // const incident_url = `https://${instance}.service-now.com/nav_to.do?uri=incident.do?sys_id=${incident_id}%26sysparm_view=ess`;
        return <button className={"btn btn-info"} value={incident_id} disabled={true}>Event Created</button>
        // return <a href={incident_url} target="_blank" rel="noreferrer">{incident_number}</a>
        // return <button className={"btn btn-info"} onClick={addIncident} value={incident_id}>{'Alert0010007'}</button>
    }
}

export const CloudServiceNowButton = params => {
    const { getAccessTokenSilently } = useVsiAppContext();

    const instance = params.data?.serviceNowInstance;
    const addIncident = async e => {

        if (e.target.innerText === 'Create Ticket') {
            e.target.disabled = true;
            const post_url = `https://${instance}.service-now.com/api/now/table/incident`;
            const newIncident =
                {
                    "short_description": params.data?.alert,
                    "comments": `Device: ${params.data?.device_name}; Flag Info: ${params.data?.description}`,
                    "urgency": params.data?.severity in ['Sev1', 'Sev0'] ? "1 - High" : "2 - Medium",
                    id: params.data?.virtual_cloud_health_detail_id
                }
            let userToken = await getAccessTokenSilently();
            let response = await UpdateVirtualHealth(post_url, newIncident, params.data?.serviceNowUser, params.data?.serviceNowPassword);
            const incident_id = response.data?.result?.sys_id;
            const incident_number = response.data?.result?.number;

            getReport(`/api/v6/report/${params.data?.stored_procedure}?id=${params.data?.id}&incident_id=${incident_id}&incident_number=${incident_number}`, null, userToken)
                .then(r => {
                    // const incident_url = `https://${instance}.service-now.com/nav_to.do?uri=incident.do?sys_id=${incident_id}%26sysparm_view=ess`;
                    e.target.innerText = incident_number;
                    e.target.value = incident_id;
                    e.target.className = "btn btn-info";
                    e.target.disabled = false;
                });
        } else {
            window.open(`https://${instance}.service-now.com/nav_to.do?uri=incident.do?sys_id=${e.target.value}%26sysparm_view=ess`);
        }
    };
    if (params?.value === undefined) {
        const cl = params.data?.severity in ['Sev1', 'Sev0'] ? "btn btn-danger" : "btn btn-warning";
        return <button className={cl} onClick={addIncident}>Create Ticket</button>
    } else if (!params?.value) {
        return null;
    } else {
        let incident_id = params?.data?.incident_id;
        let incident_number = params?.data?.incident_number;
        // const incident_url = `https://${instance}.service-now.com/nav_to.do?uri=incident.do?sys_id=${incident_id}%26sysparm_view=ess`;
        return <button className={"btn btn-info"} onClick={addIncident} value={incident_id}>{incident_number}</button>
        // return <a href={incident_url} target="_blank" rel="noreferrer">{incident_number}</a>
    }
}


function showPercentageColorBar(percentage) {
    // present percentage with length-variable bar
    let color = vsiGreen;
    let textColor = 'white';
    if (percentage >= 75 && percentage < 90) {
        color = 'yellow';
        textColor = 'black';
    } else if (percentage >= 90 && percentage < 100) {
        color = 'red';
    } else if (percentage >= 100) {
        color = 'darkblue';
    }
    if (percentage >= 5 && percentage <= 100) {
        return <div style={{width: '100%'}}>
            <div style={{backgroundColor: color, color: textColor, width: percentage + '%'}}>{percentage}%</div>
        </div>
    } else if (percentage >= 100) {
        return <div style={{width: '100%'}}>
            <div style={{backgroundColor: color, color: textColor, width: '100%'}}>{percentage}%</div>
        </div>
    } else if (percentage <= 100) {
        return <div style={{width: '100%'}}>
            <div style={{textAlign: "left"}}>{percentage}%</div>
        </div>
    } else {
        return <div style={{width: '100%'}}>
            <div style={{textAlign: "left"}}>{percentage}%</div>
        </div>
    }
}

export const percentageBarFormatter = params => {
    // Input as percentage. Ex. 0.9 => treat as 0.9%
    const percentage = Math.floor(params.value);  //I don't think you can do a 0% table cell width
    return showPercentageColorBar(percentage)
}

export const fractionPercentageBarFormatter = params => {
    // Input as percent. Ex. 0.9 => treat as 90%
    const percentage = Math.floor(params.value * 100);  //I don't think you can do a 0% table cell width
    return showPercentageColorBar(percentage)
}

export const fractionPercentageBarCeilingFormatter = params => {
    // Input as percent. Ex. 0.9 => treat as 90%. Ceiling as 100%
    var percentage = Math.floor(params.value * 100);
    if (percentage > 100) {
        percentage = 100
    }
    return showPercentageColorBar(percentage)
}

export const nAForNullFormatter = params => {
    return !params.value ? 'N/A' : params.value;
}

// export const capacityScoreFormatter = params => {
// 	const value = parseFloat(((params.value * 100) || 0).toFixed(2));
// 	const numToCheck = Math.floor(value / 10);
// 	const colorArr = [...heatColors, ...[...heatColors].reverse()];
// 	let color = colorArr[0];
// 	if (colorArr?.[numToCheck]) color = colorArr[numToCheck];
//
// 	return <span style={{ color: color }}>{value}</span>
//
// }

export const cleanNumberFormatter = params => {
    let numb = parseFloat(params?.value ?? 0);
    let str = numb.toFixed(2).toString().split(".");
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    let returnVal = str.join(".");
    if (returnVal.endsWith('.00')) {
        returnVal = returnVal.replace('.00', '');
    }
    return returnVal;
}

export const cleanIntegerFormatter = params => {
    let numb = parseInt(params?.value ?? 0);
    let str = numb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return str;
}

export const dateFormatter = params => {
    if (params.value === 0) {
        return '';
    } else {
        if (!params.value) {
            return 'Never';
        }
        return dayjs(params.value).utc().format('MM/DD/YY');
    }
}
export const dateTimeFormatter = params => {
    if (params.value === 0) {
        return '';
    } else {
        if (!params.value) {
            return 'Never';
        }
        return dayjs(params.value).utc().format('MM/DD/YYYY h:m:s.ms');
    }
}
export const cloudHealthColorAlertFormatter = params => {
    switch (params.value) {
        case 'Sev2':
            return <span className="vsiBadge healthWarning"><i className="fa-solid fa-exclamation-triangle"/></span>;
        case 'Sev0':
        case 'Sev1':
            return <span className="vsiBadge healthAlert"><i className="fa-solid fa-bell"/></span>;
        default:
            return <span className="vsiBadge healthOk"><i className="fa-solid fa-circle-heart"/></span>;
    }
}
export const shortDateFormatter = params => {
    if (params.value === 0) {
        return '';
    } else {
        if (!params.value) {
            return 'Never';
        }
        return dayjs(params.value).utc().format('MM/DD/YYYY');
    }
};

export const shortDatePlusTimeFormatter = params => {
    if (!params.value || params.value === 0) {
        return '';
    } else {
        return dayjs(params.value).format('MM/DD/YYYY h:mm A');
    }
};

export const localShortDatePlusTimeFormatter = params => {
    if (!params.value || params.value === 0) {
        return '';
    } else {
        return dayjs(params.value).utc().local().format('MM/DD/YYYY h:mm A');
    }
};

export const minuteSecondTimeFormatter = params => {
    if (params.value < 0) {
        return <span style={{fontSize: 42}}>∞</span>
    } else if (isNaN(parseInt(params.value))) {
        return params.value;
    } else {
        // const duration = dayjs.duration(params.value, 'seconds');
        return dayjs.duration(params.value, 'seconds').format('H [hours] m [minutes] s [seconds]');
    }
}

export const alertFormatter = params => {
    switch (params.value) {
        case 0.5:
            return <span className="vsiBadge healthWarning"><i className="fa-solid fa-exclamation-triangle"/></span>;
        case 0:
            return <span className="vsiBadge healthOk"><i className="fa-solid fa-circle-heart"/></span>;
        case 1:
            return <span className="vsiBadge healthAlert"><i className="fa-solid fa-bell"/></span>;
        default:
            return <span className="vsiBadge healthNotApplicable"><i className="fa-solid fa-ban"/></span>;
    }
}

export const healthFormatter = params => {
    if (parseFloat(params.value) === 0.5) {
        return <span className="vsiBadge healthWarning"><i className="fa-solid fa-exclamation-triangle"/></span>;
    } else if (parseFloat(params.value) === 1.0) {
        return <span className="vsiBadge healthAlert"><i className="fa-solid fa-bell"/></span>;
    } else if (parseFloat(params.value) === 0) {
        return <span className="vsiBadge healthOk"><i className="fa-solid fa-circle-heart"/></span>;
    } else {
        return <span className="vsiBadge healthNotApplicable"><i className="fa-solid fa-ban"/></span>;
    }
};

// 0 and 1 are flipped, but this is much easier than fixing it in the data side
export const deviceHealthFormatter = params => {
    if (parseFloat(params.value) === 0.5) {
        return <span className="vsiBadge healthWarning"><i className="fa-solid fa-exclamation-triangle"/></span>;
    } else if (parseFloat(params.value) === 0) {
        return <span className="vsiBadge healthAlert"><i className="fa-solid fa-bell"/></span>;
    } else if (parseFloat(params.value) === 1.0) {
        return <span className="vsiBadge healthOk"><i className="fa-solid fa-circle-heart"/></span>;
    } else {
        return <span className="vsiBadge healthNotApplicable"><i className="fa-solid fa-ban"/></span>;
    }
};

export const healthAlertFormatter = params => {
    switch (params.value) {
        case 'Warning':
            return <span className="vsiBadge healthWarning"><i className="fa-solid fa-exclamation-triangle"/></span>;
        case 'OK':
            return <span className="vsiBadge healthOk"><i className="fa-solid fa-circle-heart"/></span>;
        case 'Alert':
            return <span className="vsiBadge healthAlert"><i className="fa-solid fa-bell"/></span>;
        default:
            return <span className="vsiBadge healthNotApplicable"><i className="fa-solid fa-ban"/></span>;
    }
};

export const healthColorAlertFormatter = params => {
    switch (params.value) {
        case 'green':
        case 'Green':
        case '1':
        case '1.0':
        case 1:
            return <span className="vsiBadge healthOk"><i className="fa-solid fa-circle-heart"/></span>;
        case 'yellow':
        case 'Yellow':
        case '0.5':
        case 0.5:
            return <span className="vsiBadge healthWarning"><i className="fa-solid fa-exclamation-triangle"/></span>;
        case 'red':
        case 'Red':
        case '0':
        case '0.0':
        case 0:
            return <span className="vsiBadge healthAlert"><i className="fa-solid fa-bell"/></span>;
        case 'gray':
            return <span className="vsiBadge healthNotApplicable"><i className="fa-solid fa-circle-minus"/></span>;
        case undefined:
            return <span className="vsiBadge healthNotApplicable"><i className="fa-solid fa-ban"/></span>;
        default:
            return <span className="vsiBadge healthNotApplicable"><i className="fa-solid fa-ban"/></span>;
    }
};

export const nullFormatter = params => {
    if (!params.value) {
        return 'None';
    } else if (!isNaN(params.value)) {
        return parseFloat(params.value)?.toLocaleString?.("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    } else {
        return params.value;
    }
};

export const numberFormatter = params => {
    if (params.value === null || !params.value) {
        return parseFloat(0)?.toLocaleString?.("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }

    return parseFloat(params.value)?.toLocaleString?.("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2});
};

export const expiredDateFormatter = params => {
    const todayMonth = dayjs().format("MM");
    const todayYear = dayjs().format("YYYY");
    const thisMonth = params?.value?.split?.("/")?.[0];
    const thisYear = params?.value.split?.("/")?.[1];
    if (thisMonth <= todayMonth && (thisYear <= todayYear)) {
        return <div style={{color: 'red'}}>{params.value}</div>;
    }
    return params.value;
};

export const moneyFormatter = params => {
    return '$' + parseFloat(params.value || '0.00')?.toLocaleString?.("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

export const removeURIEncode = params => {
    if (params?.value?.includes('%20')) {
        return decodeURI(params.value);
    } else {
        return params.value;
    }
};

export const integerFormatter = params => {
    if (isNaN(parseInt(params.value))) return 0;
    return cleanIntegerFormatter(params);
};

export const currentFormatter = params => {
    if (isNaN(parseInt(params.value)) || parseInt(params.value) === 0) return <div>{0}</div>;
    else
        return <div style={{color: 'red'}}><b>{cleanIntegerFormatter(params)}</b></div>;
};


export const within7DaysFormatter = params => {
    let days = parseFloat(params.value);
    if (days <= 7) {
        return <span style={{
            textAlign: 'center',
            display: 'block',
            backgroundColor: '#0dbe00',
            color: 'white',
            fontWeight: 'bolder'
        }} className="label label-success">Current</span>;
    } else if (days > 7 && days < 9) {
        return <span style={{
            textAlign: 'center',
            display: 'block',
            backgroundColor: '#edcf18',
            color: 'black',
            fontWeight: "bolder"
        }} className="label label-success">7-9 Days</span>;
    } else if (days >= 9) {
        return <span style={{
            textAlign: 'center',
            display: 'block',
            backgroundColor: '#FF0000',
            color: 'white',
            fontWeight: "bolder"
        }} className="label label-success">9+ Days</span>;
    } else {
        return <span style={{
            textAlign: 'center',
            display: 'block',
            backgroundColor: '#666666',
            color: 'white',
            fontWeight: "bolder"
        }} className="label label-success">Unknown Status</span>;
    }
};

export const within1DayFormatter = params => {
    let days = parseFloat(params.value);
    if (days <= 1) {
        return <span style={{
            textAlign: 'center',
            display: 'block',
            backgroundColor: '#0dbe00',
            color: 'white',
            fontWeight: 'bolder'
        }} className="label label-success">Current</span>;
    } else if (days > 1 && days < 3) {
        return <span style={{
            textAlign: 'center',
            display: 'block',
            backgroundColor: '#FFFF00',
            color: 'black',
            fontWeight: 'bolder'
        }} className="label label-success">1-3 Days</span>;
    } else if (days >= 3) {
        return <span style={{
            textAlign: 'center',
            display: 'block',
            backgroundColor: '#FF0000',
            color: 'white',
            fontWeight: 'bolder'
        }} className="label label-success">3+ Days</span>;
    } else {
        return <span style={{
            textAlign: 'center',
            display: 'block',
            backgroundColor: '#666666',
            color: 'white',
            fontWeight: 'bolder'
        }} className="label label-success">Unknown Status</span>;
    }
};

export const growthFormatter = params => {
    switch (Math.sign(params.value)) {
        case 1: // positive
            return <div style={{color: '#6495ED'}}>+{numberFormatter(params)}</div>;
        case -1: // negative
            return <div style={{color: "#FF5757"}}>{numberFormatter(params)}</div>;
        default:
            return <div style={{color: "gray"}}>{numberFormatter(params)}</div>;
    }
};

export const intGrowthFormatter = params => {
    switch (Math.sign(params.value)) {
        case 1: // positive
            return <div style={{color: '#6495ED'}}>+{integerFormatter(params)}</div>;
        case -1: // negative
            return <div style={{color: "#FF5757"}}>{integerFormatter(params)}</div>;
        default:
            return <div style={{color: "gray"}}>{integerFormatter(params)}</div>;
    }
};

export const growthTrendDecimalFormatter = params => {
    const p = {
        ...params,
        value: parseFloat(params.value) * 100,
    }
    return growthTrendFormatter(p);
}

export const growthTrendFormatter = params => {
    const val = roundToNearestTenth(parseFloat(params.value));

    if (val > 0) {
        return <div style={{color: vsiRed}}>
            <i className="fa-regular fa-arrow-trend-up"/>
            <VsiSpanText className={"ps-1"}>+{val}%</VsiSpanText>
        </div>;
    } else if (val < 0) {
        return <div style={{color: vsiGreen}}>
            <i className="fa-regular fa-arrow-trend-down"/>
            <VsiSpanText className={"ps-1"}>{val}%</VsiSpanText>
        </div>;
    } else if (val === 0) {
        return <div style={{color: 'grey'}}>
            <i className="fa-regular fa-horizontal-rule"/>
        </div>;
    } else {
        return <div style={{color: 'grey'}}>
            <i className="fa-regular fa-horizontal-rule"/>
            <VsiSpanText className={"ps-1"}>+{val}%</VsiSpanText>
        </div>;
    }
}

export const trueGrowthTrendFormatter = params => {
    const val = parseInt(params.value);
    if (val >= 5) {
        return <div style={{color: vsiRed}}>
            <i className="fa-regular fa-arrow-trend-up"/>
            <VsiSpanText className={"ps-1"}>+{val}%</VsiSpanText>
        </div>;
    } else if (val < 0) {
        return <div style={{color: vsiGreen}}>
            <i className="fa-regular fa-arrow-trend-down"/>
            <VsiSpanText className={"ps-1"}>{val}%</VsiSpanText>
        </div>;
    } else if (val === 0) {
        return <div style={{color: 'grey'}}>
            <i className="fa-regular fa-horizontal-rule"/>
            {/*<VsiSpanText className={"ps-1"}>{val}%</VsiSpanText>*/}
        </div>;
    } else {
        return <div style={{color: 'grey'}}>
            <i className="fa-regular fa-horizontal-rule"/>
            <VsiSpanText className={"ps-1"}>+{val}%</VsiSpanText>
        </div>;
    }
}

export const growthTrendIconFormatter = params => {
    if (params.value > 0) {
        return <span className="vsiBadge healthAlert"><i className="fa-regular fa-arrow-trend-up"/></span>;
    } else if (params.value < 0) { // negative
        return <span className="vsiBadge healthOk"><i className="fa-regular fa-arrow-trend-down"/></span>;
    } else {
        return <span className="vsiBadge healthNotApplicable"><i className="fa-regular fa-horizontal-rule"/></span>;
    }
}

export const percentageGrowthFormatter = params => {
    let numVal = params?.value ?? 0;
    let val = numVal?.toFixed?.(1)?.toString?.() ?? '0';
    if (val.endsWith('.0')) {
        val = parseInt(val).toString();
    }
    if (numVal > 0) {
        return <div style={{color: '#6495ED'}}>
            <i className="fa-regular fa-arrow-trend-up"/>
            <VsiSpanText className={"ps-1"}>+{val}%</VsiSpanText>
        </div>;
    } else if (numVal < 0) {
        return <div style={{color: vsiRed}}>
            <i className="fa-regular fa-arrow-trend-down"/>
            <VsiSpanText className={"ps-1"}>{val}%</VsiSpanText>
        </div>;
    } else {
        return <div style={{color: 'grey'}}>
            <i className="fa-regular fa-horizontal-rule"/>
            <VsiSpanText className={"ps-1"}>{val}%</VsiSpanText>
        </div>;
    }
}

export const growthIconFormatter = params => {
    switch (Math.sign(params.value)) {
        case 1: // positive
            return <span className="vsiBadge healthAlert"><i className="fas fa-arrow-circle-up"/></span>;
        case -1: // negative
            return <span className="vsiBadge healthOk"><i className="fas fa-arrow-circle-down"/></span>;
        default:
            return <span className="vsiBadge healthNotApplicable"><i className="fas fa-arrow-circle-right"/></span>;
    }
}

export const redNegativeFormatter = params => {
    if (Math.sign(params.value) === -1) {
        return <span
            style={{
                backgroundColor: 'red',
                color: 'white',
                width: '100%'
            }}>{parseFloat(params.value)?.toLocaleString?.()}</span>;
    } else {
        return <span>{parseFloat(params.value)?.toLocaleString?.()}</span>;
    }
}

export const daysLeftColorFormatter = params => {
    if ((isNaN(params.value) || !params.value) && params.value !== 0) {
        return <span style={{
            display: 'block',
            textAlign: 'right'
        }}>{params.value}</span>;  //if it evals to NaN just return what came in
    } else {
        const style = {
            display: 'block',
            textAlign: 'right',
            width: '100%',
        }

        return <span style={{
            ...style,
        }}>{params.value.toFixed(0).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}</span>;
    }
}

export const tenProductRound = params => Math.round((params?.value * 10) || 0);

export const capacityScoreFormatter = params => {
    const initValue = (params.value.value && !isNaN(params.value.value)) ? params.value.value :
        (params.value && !isNaN(params.value)) ? params.value : 0;
    const value = parseFloat(initValue).toFixed(0);

    let color = getColor(value);
    // if (colorArr?.[numToCheck]) color = colorArr[numToCheck];

    const lightOrDarkFontColor = lightOrDark(color);

    return <div className="d-flex flex-row align-items-center justify-content-center">
        <div className="text-center" style={{
            borderRadius: 25,
            width: 30,
            background: color,
            color: lightOrDarkFontColor === 'light' ? 'black' : 'white'
        }}>
            <span style={{fontWeight: 'bold'}}>{value}</span>
        </div>
    </div>;
};

// keeping in memory instead of recreating every time
const powerStatesOff = ['poweredoff', 'not activated', '0', 0];
const powerStatesOn = ['poweredon', 'activated', '1', 1];

export const powerStateFormatter = params => {

  const isRed = powerStatesOff.includes((params.value ?? '').toLowerCase());
  const isGreen = powerStatesOn.includes((params.value ?? '').toLowerCase());
  if (!isRed && !isGreen) {
      return null
  }
  return (
      <span style={{
        textAlign: 'center',
        display: 'block',
        color: isRed ? 'red' : isGreen ? 'green' : 'gray',
    }}>
		<i className="fas fa-power-off"/>
	</span>
)
};

export const customLoadingCellRenderer = (props) => {
    return (
        <div
            className="ag-custom-loading-cell"
            style={{paddingLeft: '10px', lineHeight: '25px'}}
        >
            <i className="fas fa-spinner fa-pulse"></i>{' '}
            <span> {props.loadingMessage}</span>
        </div>
    );
};

export const onlineStatusFormatter = params => {
    if (params.value === 1) {
        return "On";
    }
    return "Off";
}

export const roleFormatter = params => {
    // i like mine with butter
    const spaces = params.value.replace("_", " "); // underscores to spaces
    const splitSpaces = spaces.split(" ");
    const uppercases = splitSpaces.map(word => word.charAt(0).toUpperCase() + word.slice(1));
    return uppercases.join(' ');
}

export const DataIntegrityLogFormatter = params => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (typeof params.value === 'string') {
        return params.value;
    } else {
        return (
          <>
              <Button onClick={() => setIsModalOpen(true)}>
                <i className={"fa-solid fa-scroll"}/> Logs
              </Button>
              		<VsiModal isOpen={isModalOpen}
                            size={"xl"}
                            toggle={() => setIsModalOpen(open => !open)}
                            header={
                      <VsiSpanText>
                          {params.data.deviceName} on {dayjs(params.data.dateTime).format('MM/DD/YYYY HH:mm:ss')}
                      </VsiSpanText>}
                            footer={
                      <>
                          <Button onClick={() => setIsModalOpen(false)} className={"m-1"}>
                              Close
                          </Button>
                      </>
                  }>
                      <Input type="textarea"
                             value={params.value.collectionLog}
                             maxLength={500}
                             rows={25}
                             name="note"/>
                  </VsiModal>
          </>
        )
    }
}